"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var visa_png_1 = __importDefault(require("../../img/card-icons/visa.png"));
var mastercard_png_1 = __importDefault(require("../../img/card-icons/mastercard.png"));
var discover_png_1 = __importDefault(require("../../img/card-icons/discover.png"));
var amex_png_1 = __importDefault(require("../../img/card-icons/amex.png"));
var CardTypes_1 = require("./types/CardTypes");
var SFCardIcon = function (_a) {
    var cardType = _a.cardType;
    var getCardImg = function (cardType) {
        switch (cardType) {
            case CardTypes_1.CARD_TYPES.VISA: {
                return visa_png_1.default;
            }
            case CardTypes_1.CARD_TYPES.MASTERCARD: {
                return mastercard_png_1.default;
            }
            case CardTypes_1.CARD_TYPES.DISCOVER: {
                return discover_png_1.default;
            }
            case CardTypes_1.CARD_TYPES.AMEX: {
                return amex_png_1.default;
            }
            default: {
                return '';
            }
        }
    };
    return react_1.default.createElement("img", { src: getCardImg(cardType), alt: cardType + " card type" });
};
exports.default = SFCardIcon;
